import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import { fastApiEndpoints } from '~/services/arcane-fast-api/fast-api-endpoints';

import { featureFlags } from '~/utils/featureFlags';

import { getClient } from './clients';

const FLAG = 'useFastApi';

const endpoints = () =>
  featureFlags[FLAG] ? fastApiEndpoints.conversation : apiGatewayEndpoints.conversation;

export const listConversations = () => getClient(FLAG).get(endpoints().userConversations);

export const fetchConversationById = (conversationId) =>
  getClient(FLAG).get(endpoints().conversationById(conversationId));
